import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/sensitization";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	sensitization: {
		id: "form.sensitization",
		defaultMessage: "Szenzitizációs státusz"
	},
	praCdc: {
		id: "form.sensitization.pra_cdc",
		defaultMessage: "PRA CDC"
	},
	praLuminex: {
		id: "form.sensitization.pra_luminex",
		defaultMessage: "PRA Luminex"
	},
	transplantImmunConcilium: {
		id: "form.sensitization.transplant_immun_concilium",
		defaultMessage: "Követési stratégia, kontroll javaslat"
	}
});

const fields: { [key: string]: FieldData } = {
	praCdc: {
		type: "field",
		path: ["praCdc"],
		label: messages.praCdc,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	praLuminex: {
		type: "field",
		path: ["praLuminex"],
		label: messages.praLuminex,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	transplantImmunConcilium: {
		type: "field",
		path: ["transplantImmunConcilium"],
		label: messages.transplantImmunConcilium,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.praCdc },
				{ width: 6, field: fields.praLuminex }
			]
		},
		{ columns: [{ width: 12, field: fields.transplantImmunConcilium }] }
	]
};

export const node: LeafNode = {
	id: "sensitization",
	value: {
		title: messages.sensitization,
		validator,
		fieldset,
		isImportant: true
	}
};
